import campaignPageBanner from "../../apis/campaignPageBanner";

export default {
  create({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.create(payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.delete(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.edit(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAll({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.getAll(payload);
        commit("GET_ALL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  // campaign master
  getMaster({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.getMaster();
        commit("GET_MASTER_CAMPAIGN", data.data[0]);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateMaster({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.updateMaster(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  addMaster({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.addMaster(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  //campaign partner
  get_partner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(payload);
        const { data } = await campaignPageBanner.get_partner(payload);
        commit("GET_PARTNER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_partner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.add_partner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_partner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.update_partner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_partner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.delete_partner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  //campaign Home
  get_campaignhome({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(payload);
        const { data } = await campaignPageBanner.get_campaignhome(payload);
        commit("GET_CAMPAIGN_HOME", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_campaignhome({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.add_campaignhome(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_campaignhome({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.update_campaignhome(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_campaignhome({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.delete_campaignhome(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  /// ABOUT CAMPAIGN BANNER
  get_aboutcampaignsbanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(payload);
        const { data } = await campaignPageBanner.get_aboutcampaignsbanner(
          payload
        );
        commit("GET_ABOUT_CAMPAIGN_BANNER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_aboutcampaignsbanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.add_aboutcampaignsbanner(
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_aboutcampaignsbanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.update_aboutcampaignsbanner(
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_aboutcampaignsbanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.delete_aboutcampaignsbanner(
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  /// Campaigns references
  get_campaignreference({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(payload);
        const { data } = await campaignPageBanner.get_campaignreference(
          payload
        );
        commit("GET_CAMPAIGN_REFERENCE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_campaignreference({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.add_campaignreference(
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_campaignreference({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.update_campaignreference(
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_campaignreference({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaignPageBanner.delete_campaignreference(
          payload
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
